export class ChannelData {
    data: number[] = []

    channelContent: string = ""
    fromTime: Date = new Date()
    toTime: Date = new Date()
    outputSamplingFrequency: number = 0
    isSubsampled: boolean = false

    constructor(init?: Partial<ChannelData>) {
        if (!init) {
            return
        }

        Object.assign(this, init)

        if (this.fromTime && !(this.fromTime instanceof Date)) {
            this.fromTime = new Date(this.fromTime)
        }
        if (this.toTime && !(this.toTime instanceof Date)) {
            this.toTime = new Date(this.toTime)
        }
        if (this.data) {
            for (let i = 0; i < this.data.length; i++) {
                this.data[i] = Number(this.data[i])
            }
        }
    }
}